import {Experience} from '@wix/ambassador-table-reservations-v1-experience/types'

export enum ExperienceSortOrder {
  Alphabetically = 'alphabetically',
  Manually = 'manually',
}

const getExperienceName = (experience: Experience): string =>
  experience.configuration?.displayInfo?.name ?? ''

export const sortExperiencesAlphabetically = (experiences: Experience[]): Experience[] =>
  [...experiences].sort((a, b) => getExperienceName(a).localeCompare(getExperienceName(b)))

export const sortExperiencesManually = (
  experiences: Experience[],
  manualOrder?: string[],
): Experience[] => {
  if (!manualOrder) {
    return experiences
  }

  const orderMap = new Map(manualOrder.map((id, index) => [id, index]))

  return [...experiences].sort((a, b) => {
    const indexA = orderMap.get(a.id!) ?? Number.MAX_SAFE_INTEGER
    const indexB = orderMap.get(b.id!) ?? Number.MAX_SAFE_INTEGER

    return indexA - indexB
  })
}
